var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9925 1.70373H3.28229C2.48342 1.70373 2.08397 1.70373 1.77884 1.85764C1.51044 1.99302 1.29223 2.20903 1.15547 2.47472C1 2.77677 1 3.17218 1 3.96299V10.7407C1 11.5316 1 11.927 1.15547 12.229C1.29223 12.4947 1.51044 12.7107 1.77884 12.8461C2.08397 13 2.48342 13 3.28229 13H10.1291C10.928 13 11.3275 13 11.6326 12.8461C11.901 12.7107 12.1192 12.4947 12.256 12.229C12.4114 11.927 12.4114 11.5316 12.4114 10.7407V7.70488M9.20197 2.76276L11.2192 4.75968M5.82326 6.10737L10.5649 1.41358C11.1219 0.862141 12.0252 0.862141 12.5822 1.41358C13.1393 1.96501 13.1393 2.85906 12.5822 3.41049L7.6881 8.25514C7.14492 8.79292 6.87332 9.06177 6.56393 9.27555C6.28934 9.4654 5.99315 9.62256 5.68154 9.74399C5.33043 9.88082 4.95391 9.95601 4.20086 10.1065L3.85286 10.1759L3.8867 9.94139C4.00646 9.11161 4.06634 8.69669 4.20254 8.3093C4.3234 7.96554 4.48851 7.63872 4.69378 7.33676C4.92511 6.99646 5.22451 6.70007 5.82326 6.10737Z",
    stroke: "#3597EC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.7d3a7b65b79d0fb126d2c1dc90baea7f.svg";
export { ForwardRef as ReactComponent };